// extracted by mini-css-extract-plugin
export default {"wrapper":"gratitude_wrapper__qoSIZ","logo":"gratitude_logo__zIJSF","subtitle":"gratitude_subtitle__4xJ8e","navigate_platforms":"gratitude_navigate_platforms__1i231"};